const { createAsyncThunk, createSlice } = require('@reduxjs/toolkit');
import * as evaluationFormApi from 'api/Settings/evaluationForm';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';

const InitialState = {
  data: null,
  allSopCategories: null,
  pageSize: 10,
  currentPage: 1,
  column: [
    // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 20 },
    { title: 'Text', key: 'text', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
    { title: 'Index', key: 'index', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
    { title: 'Answer Type', key: 'answer_type', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
    { title: 'Value', key: 'value', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
    { title: 'SOP', key: 'sop', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
    { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
  ],
  ui: {
    loading: false,
    msg: ''
  },
  status: 'init'
};

const getEvaluationFormData = createAsyncThunk('EvaluationFormTab/getEvaluationFormData', async (params) => {
  const res = await evaluationFormApi.getEvaluationFormData(params);
  return res.data;
});

const getAllSopCategories = createAsyncThunk('EvaluationFormTab/getAllSopCategories', async (params) => {
  const res = await evaluationFormApi.getSopCategory(params);
  return res.data;
});

const addQuestion = createAsyncThunk('EvaluationFormTab/addQuestion', async (params) => {
  const res = await evaluationFormApi.addQuestion(params);
  return res.data;
});

const updateQuestion = createAsyncThunk('EvaluationFormTab/updateQuestion', async (params) => {
  const res = await evaluationFormApi.updateQuestion(params);
  return res.data;
});

const deleteQuestion = createAsyncThunk('EvaluationFormTab/deleteQuestion', async (id) => {
  const res = await evaluationFormApi.deleteQuestion(id);
  return res.data;
});

const EvaluationFormSlice = createSlice({
  name: 'EvaluationFormTab',
  initialState: InitialState,
  reducers: {
    resetState: () => {
      return InitialState;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    }
  },
  extraReducers: {
    [getEvaluationFormData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getEvaluationFormData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.data = action.payload;
    },
    [getEvaluationFormData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getAllSopCategories.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getAllSopCategories.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.allSopCategories = action.payload;
    },
    [getAllSopCategories.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [addQuestion.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [addQuestion.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [addQuestion.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [updateQuestion.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [updateQuestion.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const updatedQuestion = state.data.data.results.map((item) => {
        if (item.id === action.payload.data.id) {
          return action.payload.data;
        }
        return item;
      });
      state.data.data.results = updatedQuestion;
    },
    [updateQuestion.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [deleteQuestion.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [deleteQuestion.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [deleteQuestion.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

export const { resetState, setCurrentPage, setPageSize } = EvaluationFormSlice.actions;

export default EvaluationFormSlice.reducer;

export { getEvaluationFormData, getAllSopCategories, addQuestion, updateQuestion, deleteQuestion };
